import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IPage } from '../../../../httpClient/serverApi/types/IPage';
import { IGetSiteAdminProfilesResult } from './GetSiteAdminProfilesRequest';

export interface IGetAdminProfilesForSiteParams {
  siteId: number;
  page?: IPage;
}

export class GetAdminProfilesForSiteRequest extends Request<
  IGetAdminProfilesForSiteParams,
  IGetSiteAdminProfilesResult
> {
  constructor(params: IGetAdminProfilesForSiteParams) {
    super('getAdminProfilesForSite', params);
  }
}
